<div class="container_global">
    <div class="flex flex-col">
        <div class="containerOutForMarkedOption" [ngStyle]="{'display':formRightComplete === false ? 'block' : 'none' }">
            <div class="containerInnerForMarkedOption">
                <div><span class="icone_graphic"></span></div>
                <span class="fontTitleMarkedOption">Clique na imagem para demarcar a área de detecção</span>
            </div>
        </div>
        <canvas #plotImageDraw class="canvas-back" width="640" height="480"
            [ngClass]="{'setBlurOnScreenshot':  formRightComplete === false, 'removeBlurOnScreenshot':formRightComplete === true}"></canvas>
        <canvas #drawAnalytic class="canvas-front" width="640" height="480" (click)="validatePointers()"></canvas>
        <div class="container-objects">
            <img src="../../../assets/img/Icons/object_icon@3x.png" [height]="objectControl[1]*1" [width]="objectControl[1]*2" class="object-large-image" id="object-large">
            <img src="../../../assets/img/Icons/object_icon@3x.png" [height]="objectControl[0]*5" [width]="objectControl[0]*2" class="object-small-image" id="object-small">
        </div>
    </div>
    <div class="config-card">
        <div [ngStyle]="{'opacity':sideRightComplete === true ? '0.5' : '1.0' }">
            <div class="first-config-row">
                <span class="title-analytics">Configurar analítico</span>
                <div *ngIf="newAnalytic.points.length > 0" [ngClass]="{'disableDiv': sideRightComplete}">
                    <i class="buttons-draw" (click)="undoDrawCanvas()" nz-icon nzType="arrow-left" nzTheme="outline"></i>
                    <i class="buttons-draw" (click)="deleteDrawCanvas()" nz-icon nzType="delete" nzTheme="outline"></i>
                </div>
            </div>
            <!-- Configuração -->
            <div class="flex flex-col justify-between" [ngClass]="{'disableDiv': sideRightComplete}">
                <div class="config-row">
                    <div style="width: 45%;">
                        <span class="label-config">Desenho</span>
                        <div class="containerColorPicker" id="color_dad">
                            <span class="dot dot-blue" style="background-color: #326ABC;"
                                (click)="getColor($event.target.attributes.style.value, 'color')" id="#326ABC"></span>
                            <label for="input-color" class="containerLabelColorInput">
                                <span class="color-picker-container-out iconColorPicker"></span>
                                <input #colorpicker class="inputNotVisible" (change)="getColor($event, 'picker')"
                                    id="input-color" type="color">
                            </label>
                        </div>
                    </div>
                    <div style="width: 45%;">
                        <span class="label-config">Iluminação ambiente</span>
                        <div class="onoffswitch">
                            <input type="checkbox" name="onoffswitch" class="onoffswitch-checkbox" id="analytics"
                                [attr.checked]="editAnalitic ? 'checked' : null" [formControl]="toogleLight">
                            <label class="onoffswitch-label switch_label" for="analytics">
                                <span class="onoffswitch-inner onoffswitch-inner-control"></span>
                                <span class="onoffswitch-switch"></span>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="config-row">
                    <div class="slider-analytic">
                        <span class="label-config">Redução de ruído ({{sensitivityDraw}}%)</span>
                        <nz-slider nzTooltipVisible="default" nzTooltipPlacement="bottom" [(ngModel)]="sensitivityDraw"
                                    [nzMarks]="marks" nzStep="1"></nz-slider>
                    </div>
                    <div class="slider-analytic">
                        <span class="label-config">Tamanho do objeto ({{objectControl[0]}}-{{objectControl[1]}}%)</span>
                        <nz-slider nzRange nzTooltipVisible="default" nzTooltipPlacement="bottom" [(ngModel)]="objectControl"
                                    [nzMarks]="marks" nzStep="1"></nz-slider>
                        <div class="slider-labels">
                            <span>Mínimo</span>
                            <span>Máximo</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
